<template>
  <div>
    <el-row style="padding-bottom: 10px" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span>
          <label>{{ $t("id") }}: </label>
          <el-input
            class="search-input"
            v-model="deviceId"
            :placeholder="$t('message.please_enter_id')"
          ></el-input>
        </span>
        <span>
          <label>{{ $t("sn") }}:</label>
          <el-input
            class="search-input"
            v-model="deviceSn"
            :placeholder="$t('message.please_enter_sn')"
          >
          </el-input
        ></span>
        <span>
          <label> {{ $t("shop.name") }}: </label>
          <DropdownSelect
            v-model="shopId"
            :action="api.dealer.shop.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </span>
        <span>
          <el-button type="primary" @click="search">{{
            $t("search")
          }}</el-button>
        </span>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.dealer.device"
      :viewable="false"
      keyField="id"
      :deletable="false"
      :editable="false"
    >
      <el-table-column prop="id" :label="$t('id')" width="50"></el-table-column>
      <el-table-column v-if="!isMobile()" prop="deviceSn" :label="$t('sn')"></el-table-column>
      <el-table-column prop="categoryName" label="设备名称"></el-table-column>
      <el-table-column
        prop="shopName"
        :label="$t('device.bind_shop')"
      ></el-table-column>
      <el-table-column
        prop="deviceTypeName"
        :label="$t('device.device_type')"
      ></el-table-column>
      <el-table-column v-if="!isMobile()"
        prop="bindDate"
        :label="$t('device.bind_time')"
        :formatter="dateFormatter"
      ></el-table-column>
      <el-table-column :label="$t('device.bind')">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.shopId == null"
            type="text"
            size="mini"
            @click="handleBind(scope.$index, scope.row)"
            >{{ $t("device.bind_shop") }}</el-button
          >
          <el-button
            v-if="scope.row.shopId != null"
            type="text"
            size="mini"
            @click="handleUnbind(scope.$index, scope.row)"
          >
            {{ $t("device.cancel_bind") }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('device.qrcode')">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="handleQrcode(scope.$index, scope.row)"
          >
            {{ $t("view") }}
          </el-button>
        </template>
      </el-table-column>
      <!--<el-table-column prop="status" label="状态"></el-table-column>-->
      <el-table-column v-if="!isMobile()"
        prop="created"
        :label="$t('created_time')"
        :formatter="dateFormatter"
      ></el-table-column>
    </page-table>
    <el-dialog title="绑定门店" :visible.sync="dialogFormVisible" :width="isMobile()?'90%':'50%'">
      <el-form :model="bindForm" label-width="30%">
        <el-form-item label="设备id">{{ bindForm.deviceId }}</el-form-item>
        <el-form-item label="序列号">{{ bindForm.deviceSn }}</el-form-item>
        <el-form-item label="门店">
          <DropdownSelect
            v-model="bindForm.shopId"
            :action="api.dealer.shop.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </el-form-item>
        <el-form-item label="设备类型">
          <DropdownSelect
            v-model="bindForm.typeId"
            :action="api.dealer.type.all"
            :params="{ shopId: bindForm.shopId }"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindShop">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看二维码" :visible.sync="qrcode.dialogVisible" :width="isMobile()?'80%':'50%'">
      <p>
        <span>下载二维码请"右击"图片选择"另存为"</span>
      </p>
      <p class="center">
        <img :src="qrcode.imageUrl" style="max-width:100%" />
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qrcode.dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      deviceId: null,
      deviceSn: "",
      shopId: null,
      dialogFormVisible: false,
      bindForm: {
        id: null,
        deviceSn: null,
        shopId: null,
        typeId: null,
      },
      qrcode: {
        dialogVisible: false,
        imageUrl: null,
      },
      deviceTypeList: [],
    };
  },
  created: function () {
    let that = this;
    let query = that.getQuery();
    that.deviceId = query.deviceId ? parseInt(query.deviceId) : null;
    that.deviceSn = query.deviceSn;
    that.shopId = query.shopId ? parseInt(query.shopId) : null;
  },
  watch: {
    "bindForm.shopId": function () {
      this.bindForm.typeId = null;
    },
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return moment(cellValue).format("yyyy-MM-DD hh:mm:ss");
    },
    search() {
      let params = this.getQuery();
      params.deviceId = this.deviceId;
      params.deviceSn = this.deviceSn;
      params.shopId = this.shopId;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function () {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
    handleBind(index, row) {
      this.bindForm.deviceId = row.id;
      this.bindForm.deviceSn = row.deviceSn;
      this.bindForm.dealerId = null;
      this.bindForm.typeId = null;
      this.dialogFormVisible = true;
    },
    bindShop() {
      let that = this;
      this.api.dealer.device
        .bindShop(Object.assign({}, this.bindForm))
        .then(function (response) {
          if (!response.data.errorCode) {
            that.dialogFormVisible = false;
            that.$message({
              type: "success",
              message: "绑定成功！",
              onClose: function () {},
            });
            that.$router.go(0);
          }
        });
    },
    handleUnbind(index, row) {
      this.$confirm("确定要解除设备与经销商绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var params = {};
        params.deviceId = row.id;
        params.shopId = row.shopId;
        this.api.dealer.device.unbindShop(params).then((response) => {
          if (!response.data.errorCode) {
            this.$router.go(0);
          }
        });
      });
    },
    handleQrcode(index, row) {
      this.qrcode.imageUrl = "/dealer/device/" + row.id + "/qrcode";
      this.qrcode.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
}
.center {
  text-align: center;
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label{
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?6c46a87a